import { render, staticRenderFns } from "./loading-status.vue?vue&type=template&id=2bbdf39a&"
import script from "./loading-status.vue?vue&type=script&lang=js&"
export * from "./loading-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbdf39a')) {
      api.createRecord('2bbdf39a', component.options)
    } else {
      api.reload('2bbdf39a', component.options)
    }
    module.hot.accept("./loading-status.vue?vue&type=template&id=2bbdf39a&", function () {
      api.rerender('2bbdf39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-status.vue"
export default component.exports